module.exports = __webpack_public_path__ + "71a3c206e13cd9dc5677faa0050a763d.svg";